<template>
  <div class="product-details-top">
    <LoadedComponent :loading="loading" />
    <div class="bg-light pb-5 mb-4" v-if="!loading">
      <nav aria-label="breadcrumb" class="breadcrumb-nav border-0 mb-0">
        <div class="container d-flex align-items-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/dashboard">Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/library">Biblioteca</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Detail</li>
          </ol>
        </div>
        <!-- End .container -->
      </nav>
      <div class="container">
        <div class="product-details product-details-centered product-details-separator">
          <h1 class="product-title">{{ library.name }}</h1>
          <div class="row d-flex justify-content-center">
            <div v-if="permission.update_biblioteca || library.owner" class="m-2">
              <router-link :to="'/library/edit/' + library.slug" class="btn btn-primary btn-sm"><i
                  class="las la-edit"></i></router-link>
            </div>

            <div v-if="permission.delete_biblioteca || library.owner" class="m-2">
              <button type="button" class="btn btn-danger btn-sm" data-toggle="modal" data-target="#delete-library">
                <i class="las la-trash-alt"></i>
              </button>
            </div>
          </div>
          <!-- End .product-title -->
        </div>

        <div class="product-details-tab">
          <div class="product-desc-content text-center">
            <h3>Descrizione articolo</h3>
            <p>{{ library.description }}</p>
          </div>
        </div>

        <div class="container quickView-container">
          <div class="quickView-content">
            <div class="row">
              <div class="col-lg-11">
                <attachment-component :attachments="library.attachments" :showname="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End .breadcrumb-nav -->
    </div>

    <div class="product-details product-details-centered product-details-separator">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <ul>


              <li v-if="library.anatomical_district != ''">
                <strong>Distretto anatomico: </strong>{{ library.anatomical_district }}
              </li>

              <li v-if="library.patology != ''">
                <strong>Patologia da: </strong>{{ library.patology }}
              </li>

              <li>
                <strong>Pubblicato da: </strong>{{ library.full_name }} il
                {{ library.created_at }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="delete-library">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Eliminazione articolo in biblioteca</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-news">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="m-4">
              <p>Sei sicuro/a di voler eliminare l'articolo in biblioteca?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="close" id="delete-modal-close-library" data-dismiss="modal" aria-label="Close">
              Annulla
            </button>
            <button type="button" class="btn btn-outline-primary" @click="deleteLibrary">
              Elimina
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import router from "@/router";
import { useAuth } from "@/stores/auth.js";
import httpservices from "@/services/httpservices.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import AttachmentComponent from "@/components/AttachmentComponent.vue";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
export default {
  name: "LibraryShow",
  props: ["slug"],
  components: { AttachmentComponent, LoadedComponent },
  data() {
    return {
      library: [],
      permission: {},
      loading: true,
    };
  },
  mounted() {
    this.loadLibrary();
    this.loadPermission();
  },
  created() { },
  methods: {
    async loadLibrary() {
      httpauth
        .get("/libraries/show/" + this.slug)
        .then((response) => {
          this.library = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async loadPermission() {
      await httpservices
        .checkPermission(1, "biblioteca", "create_biblioteca")
        .then((response) => {
          this.permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async deleteLibrary() {
      httpauth
        .get("/libraries/delete/" + this.library.slug)
        .then((response) => {
          localStorage.setItem("successMessageLibrary", response.data.message);
          $("#delete-modal-close-library").click();
          router.push("/library");
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
  },
};
</script>